import * as Yup from 'yup';

export const installationSchema = (isInMultiGroupForm) => Yup.object().shape({
  osInfo: Yup.string().required('Campo obrigatório'),
  inputSerial: Yup.string().nullable(),
  ...(isInMultiGroupForm ? {} : { notes: Yup.string().required('Campo obrigatório') })
})

export const eventSchema = (isInMultiGroupForm) => Yup.object().shape({
  osInfo: Yup.string().required('Campo obrigatório'),
  inputSerial: Yup.string().required('Campo obrigatório'),
  outputSerial: Yup.string().required('Campo obrigatório'),
  defects: Yup.string().required('Campo obrigatório: selecione corretamente a classificação do defeito para continuar com a escolha da solução.').nullable(),
  solutions: Yup.string().required('Campo obrigatório: selecione corretamente a classificação do defeito para continuar com a escolha da solução.').nullable(),
  ...(isInMultiGroupForm ? {} : { notes: Yup.string().required('Campo obrigatório') })
})

export const exchangeSchema = (isInMultiGroupForm) => Yup.object().shape({
  osInfo: Yup.string().required('Campo obrigatório'),
  inputSerial: Yup.string().nullable(),
  outputSerial: Yup.string().required('Campo obrigatório'),
  defects: Yup.string().required('Campo obrigatório: selecione corretamente a classificação do defeito para continuar com a escolha da solução.').nullable(),
  solutions: Yup.string().required('Campo obrigatório: selecione corretamente a classificação do defeito para continuar com a escolha da solução.').nullable(),
  ...(isInMultiGroupForm ? {} : { notes: Yup.string().required('Campo obrigatório') })
})

export const maintenanceSchema = (isInMultiGroupForm) => Yup.object().shape({
  osInfo: Yup.string().required('Campo obrigatório'),
  inputSerial: Yup.string().required('Campo obrigatório'),
  outputSerial: Yup.string().required('Campo obrigatório'),
  defects: Yup.string().required('Campo obrigatório: selecione corretamente a classificação do defeito para continuar com a escolha da solução.').nullable(),
  solutions: Yup.string().required('Campo obrigatório: selecione corretamente a classificação do defeito para continuar com a escolha da solução.').nullable(),
  ...(isInMultiGroupForm ? {} : { notes: Yup.string().required('Campo obrigatório') })
})

export const supplySchema = (isInMultiGroupForm) => Yup.object().shape({
  osInfo: Yup.string().required('Campo obrigatório'),
  supplyKit: Yup.string().required('Campo obrigatório'),
  supplyKitAmount: Yup.string().test(
      'wei-not-zero', 
      'O valor não pode ser zero', 
      (value) => parseFloat(value) !== 0
    ).required('Campo obrigatório'),
  ...(isInMultiGroupForm ? {} : { notes: Yup.string().required('Campo obrigatório') })
})

export const uninstallationSchema = (isInMultiGroupForm) => Yup.object().shape({
  osInfo: Yup.string().required('Campo obrigatório'),
  outputSerial: Yup.string().required('Campo obrigatório'),
  ...(isInMultiGroupForm ? {} : { notes: Yup.string().required('Campo obrigatório') })
})
